import { render } from "./confirmAccountDeletionModal.vue?vue&type=template&id=cb998180&scoped=true&ts=true"
import script from "./confirmAccountDeletionModal.vue?vue&type=script&lang=ts"
export * from "./confirmAccountDeletionModal.vue?vue&type=script&lang=ts"

import "./confirmAccountDeletionModal.vue?vue&type=style&index=0&id=cb998180&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb998180"]])

export default __exports__